/**
 * This is used to intercept all the service requests from the client
 * It will add the authToken in the sevice request headers
 */

import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { finalize } from 'rxjs/operators';

import { CommonService } from '../common/services/common.service';
import { AuthService } from './auth.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
    constructor(private _router: Router, private _injector: Injector) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const authService = this._injector.get(AuthService);
        const commonService = this._injector.get(CommonService);

        const skipLoaderAPIs = [authService.baseUrl + 'airpool/airports',
                                authService.baseUrl + 'airpool/pricing',
                                authService.baseUrl + 'payment/getbankslist'];

        let authReq = req;
        if (req.url !== authService.baseUrl + 'users/authenticate') {
          authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${authService.getToken()}`
            }
          });
        }

        if (!skipLoaderAPIs.includes(authReq.url)) { commonService.showLoader(); }
        return next.handle(authReq).pipe(
              finalize(() => commonService.hideLoader())
        );
    }
}
